<template>
  <div class="TroubleShooting" @click="toggleProblemDialog()">
    <div class="tr-container" @click="$event.stopPropagation()">
      <div class="tr-wrapper">

        <!-- TITLE -->
        <div class="ts-title">{{ $t('Problembehandlung') }}</div>

        <md-list :md-expand-single="true">

          <!-- -->
          <md-list-item md-expand>
            <span class="md-list-item-text">{{ $t('Ich höre niemanden') }}</span>
            <md-list :md-expand-single="true" slot="md-expand">
              <md-list class="sub-list" :md-expand-single="true">
                <md-list-item md-expand>
                  <span class="md-list-item-text">{{ $t('Das Standardkommunikationsgerät umstellen (Windows 10)') }}</span>
                  <md-list :md-expand-single="true" slot="md-expand">
                    <md-list-item class="md-inset">
                      <div class="solution-description">
                        {{ $t(`Öffnen Sie die Soundeinstellungen 
                        (am besten direkt in die Suche eingeben). Scrollen Sie nach unten, bis Sie zur Überschrift "Verwandte Einstellungen"
                        gelangen. Darunter klicken Sie auf "Sound-Systemsteuerung". Es öffnet sich ein kleines Fenster, in dem verschiedene
                        Ausgabegeräte zu sehen sind. Machen Sie einen Rechtsklick auf das Gerät, das Sie verwenden möchten und klicken
                        Sie dann auf "Als Standardkommunikationsgerät auswählen". Nun sollte das korrekte Gerät für die Ausgabe verwendet
                        werden.`) }}         
                      </div>
                    </md-list-item>
                  </md-list>
                </md-list-item>
              </md-list>
            </md-list>
          </md-list-item>

          <!-- -->
          <md-list-item md-expand>
            <span class="md-list-item-text">{{ $t(`Ich höre Echogeräusche`) }}</span>
            <md-list :md-expand-single="true" slot="md-expand">
              <md-list class="sub-list" :md-expand-single="true">
                <md-list-item md-expand>
                  <span class="md-list-item-text">{{ $t(`Ein Headset verwenden`) }}</span>
                  <md-list :md-expand-single="true" slot="md-expand">
                    <md-list-item class="md-inset">
                      <div class="solution-description">
                        {{ $t(`Wenn Sie ein Notebook oder ein ähnliches Gerät verwenden, kann es sein, dass der Lautsprecher und das
                        Mikrofon zu nah beieinander sind und der Ton aus dem Lautsprecher direkt vom Mikrofon aufgenommen wird.
                        Dadurch hört Ihr Gegenüber die eigene Stimme, was es schwieriger macht, sich auf das Gespräch zu
                        konzentrieren. Wenn dies der Fall ist, schießen Sie bitte ein Headset an.`) }}         
                      </div>
                    </md-list-item>
                  </md-list>
                </md-list-item>

                <md-list-item md-expand>
                  <span class="md-list-item-text">{{ $t(`Nur ein Mikrofon und einen Lautsprecher pro Raum verwenden`) }}</span>
                  <md-list :md-expand-single="true" slot="md-expand">
                    <md-list-item class="md-inset">
                      <div class="solution-description">
                        {{ $t(`Wenn Sie mit weiteren Personen an einer Tour teilnehmen und sich diese Personen im selben Raum
                        been wie Sie, kann es sein, dass das ihre Stimme mehrmals aufgenommen wird und Echo Geräusche entstehen. 
                        Achten Sie daher darauf, dass nur ein Microfon aktiviert ist oder die Personen weitgenug auseinander sitzen.`) }}         
                      </div>
                    </md-list-item>
                  </md-list>
                </md-list-item>
              </md-list>
            </md-list>
          </md-list-item>

          <!-- -->
          <md-list-item md-expand>
            <span class="md-list-item-text">{{ $t(`Meine Kamera/Mikrofon wird nicht erkannt`) }}</span>
            <md-list :md-expand-single="true" slot="md-expand">
              <md-list class="sub-list" :md-expand-single="true">
                <md-list-item md-expand>
                  <span class="md-list-item-text">{{ $t(`Erlauben Sie den Zugriff`) }}</span>
                  <md-list :md-expand-single="true" slot="md-expand">
                    <md-list-item class="md-inset">
                      <div class="solution-description">
                        {{ $t(`Beim Öffnen der Mikrofon- und Kameraeinstellungen fragt der Browser nach dem Zugriff auf Ihre
                        Mikrofone und Kameras. Ohne Ihre Erlaubnis kann die Anwendung ihre Kamera und Mikrofon nicht nutzen.
                        Überprüfen Sie die Mikrofon- und Kameraeinstellungen ihres Browsers, falls Sie nicht nach dem Zugriff gefragt werden.`) }}         
                      </div>
                    </md-list-item>
                  </md-list>
                </md-list-item>

                <md-list-item md-expand>
                  <span class="md-list-item-text">{{ $t(`Ändern Sie die Datenschutzeinstellungen`) }}</span>
                  <md-list :md-expand-single="true" slot="md-expand">
                    <md-list-item class="md-inset">        
                      <div class="solution-description">
                        {{ $t(`Ihr Betriebssystem kann dem Browser den generellen Zugriff auf die Kamera und Mikrofon blockieren. 
                        Überprüfen sie die Datenschutzeinstellungen ihres Betriebssystemes, und erlauben Sie ihrem Browser ggf. Zugriff!`) }}         
                      </div>
                    </md-list-item>
                  </md-list>
                </md-list-item>

                <md-list-item md-expand>
                  <span class="md-list-item-text">{{ $t(`Kamera/Mikrofon wird bereits genutzt`) }}</span>
                  <md-list :md-expand-single="true" slot="md-expand">
                    <md-list-item class="md-inset">
                      <div class="solution-description">
                        {{ $t(`Es könnte sein, dass andere Anwendungen wie Microsoft Teams oder ein anderer geöffneter Browser bereits Kamera oder Mikrofon nutzen. 
                        Stellen Sie sicher, das ihre Kamera nicht von anderen Anwendungen genutzt wird und schließen Sie diese Anwendungen gegebenenfalls.`) }}
                      </div>
                    </md-list-item>
                  </md-list>
                </md-list-item>
              </md-list>
            </md-list>
          </md-list-item>

          <md-list-item md-expand>
            <span class="md-list-item-text">{{ $t(`Beim Audiotest wird meine Audio nicht übertragen`) }}</span>
            <md-list :md-expand-single="true" slot="md-expand">
              <md-list class="sub-list" :md-expand-single="true">
                <md-list-item md-expand>
                  <span class="md-list-item-text">{{ $t(`Die Firewall-Einstellungen anpassen`) }}</span>
                  <md-list :md-expand-single="true" slot="md-expand">
                    <md-list-item class="md-inset">
                      <div class="solution-description">
                        {{ $t(`Zur Kommunikation mit dem Server ist es notwendig, dass Sie den TCP Port 443 freigeben. Wenn Sie eine
                        Whitelist für Domains pflegen, ist es außerdem wichtig, dass Sie die Domains "*.tokbox.com" und
                        "*.opentok.com" (ohne Anführungszeichen) in die Liste einfügen.`) }}
                      </div>
                    </md-list-item>
                  </md-list>
                </md-list-item>

                <md-list-item md-expand>
                  <span class="md-list-item-text">{{ $t(`Die Proxy-Einstellungen anpassen`) }}</span>
                  <md-list :md-expand-single="true" slot="md-expand">
                    <md-list-item class="md-inset">
                      <div class="solution-description">
                        {{ $t(`Am besten funktioniert der Videochat ohne einen Proxy. Wenn Sie ohne Proxy keinen Zugang zum Internet
                        haben, sollten Sie einen transparenten Proxy verwenden oder den Proxy im Browser für HTTPS-Verbindungen
                        konfigurieren.`) }}
                      </div>
                    </md-list-item>
                  </md-list>
                </md-list-item>
              </md-list>
            </md-list>
          </md-list-item>


          <md-list-item md-expand>
            <span class="md-list-item-text">{{ $t(`Sonstiges`) }}</span>
            <md-list :md-expand-single="true" slot="md-expand">
              <md-list class="sub-list" :md-expand-single="true">
                <md-list-item md-expand>
                  <span class="md-list-item-text">{{ $t(`Unterstützte Browser`) }}</span>
                  <md-list :md-expand-single="true" slot="md-expand">
                    <md-list-item class="md-inset">
                      <div class="solution-description">
                        {{ $t(`Am besten wird die Anwendung von den Browsern Firefox, Chrome, Safari, Opera und Edge unterstützt. Achten Sie bitte
                        darauf, dass Sie die jeweils aktuelle Version installiert haben und aktualisieren Sie diese ggf. manuel, da die Browser dies nicht immer automatisch tun.`) }}
                      </div>
                    </md-list-item>
                  </md-list>
                </md-list-item>
              </md-list>
            </md-list>
          </md-list-item>

        </md-list>
      </div>
      <md-button style="margin-top: 15px; width: 150px; height: 45px" class="normal-md-button" @click="toggleProblemDialog();" >{{$t('Zurück')}}</md-button>
    </div>
  </div>
</template>

<script>
export default {
name: "TroubleShooting",
  props: {
    toggleProblemDialog: Function,
  },
}
</script>

<style scoped>
.TroubleShooting{
  width: 100%;
  height: 100%; 
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9;
  background: #000000e3;
}

.tr-container{
  width: 800px;
}

.tr-wrapper{
  background: white;
  border-radius: 10px; 
  padding-top: 2px;
}

.ts-title{
  font-size: 1.6em;
  text-align: left;
  color: black;
  margin-left: 20px;
  margin-bottom: 25px;
  margin-top: 25px;
}
.solution-description{
  white-space: normal;
}

.md-list{
  background-color: #8f8f8f;
  padding: 0;
}
.md-list, .md-list *{
  border-radius: 2px;
  color: black;
}
.md-list .sub-list .md-list-item-text{
  padding-left: 10px;
}
.md-list-item .md-list-item{
  background-color: #b8b8b8;
}
.sub-list .md-list-item.md-inset{
  background-color: #f3f3f3;
}
.md-list.md-theme-default .md-list-item-expand.md-active{
  border: none;
}
.md-button{
  --md-theme-default-text-primary-on-background: #ffffff;
}

@media screen and (max-width: 900px) {
  .tr-container{
    width: 90%;
  }
}
</style>